import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { ChevronDownOutline } from '@olist/design-system-icons';
import Button from '../Button/Button.js';

const DropdownToggle = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Button, Object.assign({}, props, { ref: ref, variation: "secondary", iconRight: ChevronDownOutline, size: "medium", "aria-haspopup": true, type: "button" }), children));
});
DropdownToggle.displayName = 'DropdownToggle';

export { DropdownToggle as default };
